import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import type { DocumentTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-find.dto';
import { DocumentTypeService } from '@zaoblako/web/core/services/finance/document-type.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { buildDocumentTypeTreeOptions, type DocumentTypeTreeOption } from '@zaoblako/web/shared/dumbs/dropdowns/build-document-type-tree-options.util';
import { TreeSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/tree-select/tree-select.component';

@Component({
  selector: 'crm-document-type-single-select',
  standalone: true,
  imports: [CommonModule, TreeSelectComponent],
  templateUrl: './document-type-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentTypeSingleSelectComponent implements OnInit {
  public options: DocumentTypeTreeOption[] = [];

  @Input() public selectedDocumentType: DocumentTypeFindInterface;
  @Output() public selectedDocumentTypeChange = new EventEmitter<DocumentTypeFindInterface>();

  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;
  @Input() public isNotSync1c = false;

  private _documentTypes: DocumentTypeFindInterface[] = [];

  @Input() public set documentTypes(documentTypes: DocumentTypeFindInterface[]) {
    this._documentTypes = Array.isArray(documentTypes) ? documentTypes : [];
    this.options = buildDocumentTypeTreeOptions(this._documentTypes);
  }

  public constructor(
    private readonly documentTypeService: DocumentTypeService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled
    ) {
      this.documentTypeService.find<DocumentTypeFindInterface>().subscribe({
        next: (documentTypes) => {
          let types = documentTypes;
          if (this.isNotSync1c) {
            types = types.filter((type) => !type.sync1c);
          }
          this.documentTypes = types;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
